/** Empty shell — kept for backward-compatible type tokens; actual line-item data is carried by `DocItems` in `document.ts`. */
export class DocItems {

}

/** Document header row for list display — primary DB fields, computed sums, and boolean visual-state flags (fs/ps/fp/pp/np/go/td/fd). */
export class DocListEntry {

  DOCID?: number ;
  DOCTYPEID?: number;
  DOCDATE?: Date;
  DOCEXPDATE?: Date;
  DOCVALDATE?: Date;
  DOCCLIENTSID?: number;    /* DOCCLIENTSID Exactly */
  DOCPERSONID?: number ;
  DOCMANCLIID?: number ;
  DOCMANPERID?: number ;
  DOCNUMBER?: string;
  DOCNOTE1?: string;
  DOCNOTE2?: string;
  PRIMDOCID?: number ;
  DOCCLIDEPID?: number ;
  DOCMANDEPID?: number ;
  DOCCURRID?: number ;
  DOCRATEVAL?: number ;
  DOCACTIVE?: boolean;
  DOCFLAG?: number ;
  CLIENTSNAME?: string;   /* PCOCLINAME - full name of partner legal entity */
  DOCPCOCLIID?: number;   /* DOCPCOCLIID Exactly */
  LOCALCOMP?: string;
  PERSONNAME?: string;
  DOCNAME?: string;
  DOCSUM?: number;
  PAYDSUM?: number;
  SHIPSUM?: number;
  DOCVSUM?: number;       // Placeholders for currency related result
  PAYDVSUM?: number;      // It is the currency given in request
  SHIPVSUM?: number;      // NOT DOCUMENT'S currency
  AUTHOR?: string;
  CURSTR?: string;
  LOCALCOMPID?: number;
  PAIDJUSTNOW?: number;
  PAIDNOWDATE?: Date;
  DOCITEMS?: DocItems[];
  PARTNERNAME?: string;          /* CLIENTSNIKNAME of partner main company */
  PARTNERNAMESTR?: string;      /* Combined name (CLIENTNIKNAME or PCO_CLIENTNIKNAME (CLIENTNIKNAME)) */
  PARTNERNIKNAME?: string;       /* CLIENTNIKNAME of partner legal entity */

  fs?: boolean;                 /* visual state primitives: True if Fully shipped */
  ps?: boolean;                 /* visual state primitives: True if partually shipped */
  fp?: boolean;                 /* visual state primitives: True if Fully paid */
  pp?: boolean;                 /* visual state primitives: True if partually paid */
  np?: boolean;                 /* visual state primitives: True if not paid (shiiped gt paiment) */
  go?: boolean;                 /* visual state primitives: True if not valid (expired) should be grayed out */

  td?: boolean;                 /* visual state primitives: True if document is today */
  fd?: boolean;                 /* visual state primitives: True if document is in feature (tomorrow) */
}

/** Maps a `DocTypes` DB row — document type definition with kind, names, security group, and text templates. */
export class DocTypes {
  DOCTYPEID: number;
  DOCKIND: number;
  DOCNAME: string;
  DOCNAME1: string;
  DOCNOTE: string;
  DOCSGROUP1: string;
  DOCSECGROUPID: number;
  DOCUSEFORFACTTABLE: number;
  DOCTEXTBEFORE: string;
  DOCTEXTAFTER: string;

  DEFAULTVALTERM?: number;
  DEFAULTEXPTERM?: number;
  OPTIONALPARMSTR?: string;

  OPTIONALPARAMS?: any;

}


/*

[DOCTYPEID]
      ,[DOCKIND]
      ,[DOCNAME]
      ,[DOCNOTE]
      ,[DOCSGROUP1]
      ,[DOCSECGROUPID]
      ,[DOCUSEFORFACTTABLE]
      ,[DOCNAME1]
      ,[DOCTEXTBEFORE]
      ,[DOCTEXTAFTER]

    this.docTypes =
       [
        { "DOCTYPEID": 1, "DOCKIND": 1, "DOCNAME": "Договор-Заказ", "DOCNAME1": "Договор на поставку", "DOCSGROUP1": "Выписано счетов" },
        { "DOCTYPEID": 2, "DOCKIND": 2, "DOCNAME": "Приходная накладная", "DOCNAME1": "Накладная на прием ТМЦ", "DOCSGROUP1": "Принято товара" },
        { "DOCTYPEID": 3, "DOCKIND": 2, "DOCNAME": "Накладная на импорт", "DOCNAME1": null, "DOCSGROUP1": "Принято импортного товара" },
        { "DOCTYPEID": 4, "DOCKIND": 2, "DOCNAME": "Расходная накладная", "DOCNAME1": "Накладная на отпуск ТМЦ", "DOCSGROUP1": "Отгружено товара" },
        { "DOCTYPEID": 5, "DOCKIND": 2, "DOCNAME": "Накладная на перемещение", "DOCNAME1": null, "DOCSGROUP1": null },
        { "DOCTYPEID": 6, "DOCKIND": 3, "DOCNAME": "Налоговая накладная", "DOCNAME1": null, "DOCSGROUP1": null },
        { "DOCTYPEID": 7, "DOCKIND": 3, "DOCNAME": "Спецификация / Гарантийный талон", "DOCNAME1": null, "DOCSGROUP1": null },
        { "DOCTYPEID": 8, "DOCKIND": 4, "DOCNAME": "Приходные кассовый ордер", "DOCNAME1": "Приходные кассовый ордер", "DOCSGROUP1": "Оплачено" },
        { "DOCTYPEID": 9, "DOCKIND": 4, "DOCNAME": "Банковская выписка", "DOCNAME1": "Платежное поручение покупателя", "DOCSGROUP1": "Оплачено" },
        { "DOCTYPEID": 10, "DOCKIND": 1, "DOCNAME": "Требование-заказ для поставщика", "DOCNAME1": "Purchase order", "DOCSGROUP1": null },
        { "DOCTYPEID": 11, "DOCKIND": 4, "DOCNAME": "Взаимозачет", "DOCNAME1": "Залог", "DOCSGROUP1": "Оплачено" },
        { "DOCTYPEID": 12, "DOCKIND": 1, "DOCNAME": "Коммерческое предложение", "DOCNAME1": "Коммерческое предложение", "DOCSGROUP1": null },
        { "DOCTYPEID": 14, "DOCKIND": 2, "DOCNAME": "Инвентаризация", "DOCNAME1": "Инвентаризация склада", "DOCSGROUP1": "Отаток товаров на складе" },
        { "DOCTYPEID": 15, "DOCKIND": 4, "DOCNAME": "Сверка по взаиморасчетам", "DOCNAME1": "Balance amount", "DOCSGROUP1": "Сверка по балансам" },
        { "DOCTYPEID": 16, "DOCKIND": 3, "DOCNAME": "Паспорт", "DOCNAME1": null, "DOCSGROUP1": null }]
      ;
*/
